import React from "react";
import { getString } from "../../utilities";

export default function Confirm({
  children,
  confirm,
  button = getString("ok"),
  cancel,
  cancelButton = getString("cancel.1"),
}) {
  return (
    <div className="modal-content-confirm">
      {children}
      <div className="modal-content-confirm-buttons">
        <button
          className="button-flat-color pt-green"
          type="button"
          onClick={confirm}
          data-testid={`${button}-confirm-button`}
        >
          {button}
        </button>
        <button className="button-flat-color pt-orange" type="button" onClick={cancel}>
          {cancelButton}
        </button>
      </div>
    </div>
  );
}
